import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-phone-in-talk",
  templateUrl: "./med-icon-phone-in-talk.component.html",
})
export class MedIconPhoneInTalkComponent extends SvgMixinComponent {}
